import { ReviewLinkPlatform } from '@rma/dashboard/settings/public/api-review-links';

export const SocialMediaChannel = {
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  Twitter: 'Twitter',
  LinkedIn: 'LinkedIn',
  GoogleMyBusiness: 'GoogleMyBusiness',
} as const;

export type SocialMediaChannel = (typeof SocialMediaChannel)[keyof typeof SocialMediaChannel];

export const SocialMediaChannel2 = {
  facebook: 'facebook',
  instagram: 'instagram',
  twitter: 'twitter',
  linkedIn: 'linkedIn',
  googleMyBusiness: 'googleMyBusiness',
} as const;

export type SocialMediaChannel2 = (typeof SocialMediaChannel2)[keyof typeof SocialMediaChannel2];

export function isFacebookOrInstagram(channel: SocialMediaChannel) {
  return [SocialMediaChannel.Facebook.toString(), SocialMediaChannel.Instagram.toString()].includes(channel);
}

export type ChannelOrPlatform = SocialMediaChannel | SocialMediaChannel2 | ReviewLinkPlatform;
